<template>
<section class="dl-notice">
  <h2 class="dl-notice__title">Secure VPN APK Compatibility</h2>
  <div class="dl-notice__body">
    <p>
      Secure VPN is designed for
      <router-link to="/vpn-for-android/">Android devices</router-link>
      and can be installed manually using the APK package. Make sure your device has enough free storage and allows installation from external sources.
    </p>
    <h3>FAQ</h3>
    <p><strong>Is Secure VPN APK free?</strong> Yes. This page provides the Secure VPN APK for free download.</p>
    <p><strong>Can I install Secure VPN without Google Play?</strong> Yes. You can manually install the APK on a compatible Android device.</p>
    <p><strong>Does Secure VPN require root?</strong> No. Root access is not normally required to use a VPN app on Android.</p>
    <p><strong>How do I update Secure VPN?</strong> Download the newest APK version and install it over your existing version. Keep your current app installed if you want to preserve its existing settings.</p>
  </div>
</section>
</template>

<script>
export default {
  name: 'DownloadNoticeSection',
}
</script>

<style lang="scss" scoped>
.dl-notice {
  padding: 28px 32px;
  border-radius: 24px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(245, 241, 255, 0.98) 100%);
  box-shadow: 0 12px 32px rgba(109, 74, 255, 0.06);
  box-sizing: border-box;
}

.dl-notice__title {
  margin: 0 0 16px;
  text-align: left;
  font-size: clamp(24px, 2.8vw, 32px);
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--vpn-ink, #1f2430);
  font-weight: 800;
}

.dl-notice__body {
  width: 100%;

  p {
    margin: 0 0 14px;
    width: 100%;
    max-width: 100%;
    text-align: left;
    color: var(--vpn-ink-muted, #5b6475);
    font-size: 15px;
    line-height: 1.7;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 768px) {
  .dl-notice {
    padding: 18px 14px;
    border-radius: 16px;
  }

  .dl-notice__title {
    margin-bottom: 12px;
    font-size: clamp(20px, 5.5vw, 26px);
  }

  .dl-notice__body p {
    font-size: 14px;
    line-height: 1.65;
  }
}
</style>
